import React, { Fragment, Component } from "react";
import Tooltip from "rc-tooltip";
import { FaClipboard } from "react-icons/fa";
import styled from "styled-components";
import { FaRegCheckCircle } from "react-icons/fa";
import "./formsubmitted.scss";
import { withRouter, NavLink } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";

class FormSubmitted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToolTip: false,
    };
  }

  onCopy = (e) => {
    this.setState({
      showToolTip: true,
    });
    this.textArea.select();
    document.execCommand("copy");
    if (window.getSelection) {
      if (window.getSelection().empty) {
        // chrome/safari
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) {
        // firefox
        window.getSelection().removeAllRanges();
      }
    } else if (document.selection) {
      // ie
      document.selection.empty();
    }
    let that = this;
    setTimeout(function () {
      that.setState({
        showToolTip: false,
      });
    }, 1000);
  };

  onClickReturnToDashboard = () => {
    this.props.history.push("/dashboard/");
  };

  render() {
    const isQueueError = this.props?.location?.state?.queueError;
    // let formType = "";

    const ServerSideWrapper = styled.section`
      h5 {
        margin-bottom: 0px;
      }
      p {
        margin-top: 0px;
        font-size: 15px;
        line-height: 26px;
      }
      textarea {
        background: transparent;
        border: 0px;
        width: 100%;
        height: 220px;
        margin: 0px;
        &:focus {
          outline: 0px;
        }
      }
      svg:hover {
        opacity: 0.5 !important;
      }
    `;
    let // formName,
      successMessage,
      errorMessage = (
        <>
          <p>
            An error occurred in the receipt of your application. The
            Department’s case processing system did not successfully transmit
            your application for assignment of a permanent case number. You may
            reopen your application from your{" "}
            <NavLink to="/dashboard/cases">Initiated Cases table</NavLink> and
            resubmit or contact the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://flag.dol.gov/support/contact"
            >
              Technical Help Desk
            </a>{" "}
            for assistance.
          </p>
        </>
      );

    successMessage = (
      <>
        <p>
          Your submitted application is now being transmitted for assignment of
          a case number. Once this process completes, you will receive a
          courtesy email notification. Although your application will remain in
          the{" "}
          <NavLink to="/dashboard/cases">
            <strong>Pending Case Number</strong>
          </NavLink>{" "}
          table under the temporary application ID number until this process
          completes, please be assured that your application is received and the
          date referenced with this application in your FLAG account confirms
          official submission to the Department.
        </p>

        <p>
          If you do not receive a permanent case number or a courtesy email
          notification, please contact our{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://flag.dol.gov/support/contact"
          >
            Technical Help Desk
          </a>{" "}
          for assistance.
        </p>
      </>
    );
    let successQueueErrorMessage = (
      <>
        <p>
          FLAG encountered a technical issue during submission of your case and
          the IT team is investigating. No further action is needed by you, but
          please be aware you may experience a delay in receiving confirmation
          of your case submission.
        </p>

        <p>
          For any questions, please contact our{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://flag.dol.gov/support/contact"
          >
            Technical Help Desk
          </a>{" "}
          for assistance.
        </p>
      </>
    );
    if (
      this.props?.location?.state?.error &&
      Object.keys(this.props.location.state.error).length > 0
    ) {
      let errorJSON = this.props.location.state.error.result;
      let errorReport = [];
      if (typeof errorJSON === "string") {
        errorReport.push(errorJSON);
      } else {
        Object.entries(errorJSON).forEach((x) => {
          if (
            !x[0].includes("stacktrace") &&
            !x[0].includes("exception") &&
            !x[0].includes("code")
          ) {
            if (typeof x[1] === "object" && !(x[1] instanceof Array)) {
              // let obj = {
              //   machine_name: x[0],
              //   errors: x[1][0]["error"],
              // };
              let cleanTitle = x[0]
                .split("_")
                .map((x) => x.charAt(0).toUpperCase() + x.substring(1))
                .join(" ");
              errorReport.push(`${cleanTitle}: \n`);
              for (let error of Object.entries(x[1][0]["error"])) {
                if (error[0] === "f13b_source_year") {
                  error[1] =
                    "One or more Entries for Place of Employment contain wage data from the previous Series and Source Year. Please update each entry to use the latest wage data.";
                }
                errorReport.push(`${error[0]}: ${error[1]}`);
              }
            } else {
              if (x?.[1]?.[0]?.extensions?.submission_error?.[0]) {
                errorReport.push(
                  `${x[1][0].extensions?.submission_error?.[0]} \n`
                );
              } else {
                errorReport.push(`${x[0]}: ${x[1]} \n`);
              }
            }
          }
        });
      }
      let { application_id, type } = this.props.location.state;
      let errorHeader = (
        <>
          <h5>What happened?</h5>
          <p>
            An error occurred in the receipt of your application. The
            Department’s case processing system did not successfully transmit
            your application{" "}
            <code
              style={{
                padding: "5px 5px",
                position: "relative",
                background: "rgb(247, 247, 247)",
                borderRadius: "5px",
              }}
            >
              {application_id}
            </code>{" "}
            for assignment of a permanent case number.
          </p>
        </>
      );
      let errorBox = (
        <div
          style={{
            fontSize: "0.75rem",
            padding: "10px 20px",
            position: "relative",
            background: "#f7f7f7",
            borderRadius: "10px",
          }}
        >
          <Tooltip
            visible={this.state.showToolTip}
            placement="right"
            overlayStyle={{ width: "77px" }}
            transitionName="fadeOutRight"
            trigger={["click"]}
            overlay={<span>Copied!</span>}
          >
            <FaClipboard
              onClick={this.onCopy}
              style={{
                cursor: "pointer",
                transition: "opacity .25s",
                position: "absolute",
                top: "20px",
                right: "20px",
                fontSize: "26px",
                opacity: ".25",
              }}
            ></FaClipboard>
          </Tooltip>
          <textarea ref={(textarea) => (this.textArea = textarea)}>
            {errorReport.join("")}
          </textarea>
        </div>
      );
      switch (type) {
        case "Server Side Errors":
          errorMessage = (
            <ServerSideWrapper>
              {errorHeader}
              <h5>Where did my application go?</h5>
              <p>
                It’s still here! You may re-open your application from your{" "}
                <NavLink to="/dashboard/cases/initiated">
                  Initiated Cases Table.
                </NavLink>
              </p>
              <h5>What should I do now?</h5>
              <p>
                Go to your{" "}
                <NavLink to="/dashboard/cases/initiated">
                  Initiated Cases Table
                </NavLink>{" "}
                and open the application for editing. Check the fields
                identified in the error message to ensure they are filled out
                correctly, then resubmit. If this does not work, contact the{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://flag.dol.gov/support/contact"
                >
                  Technical Help Desk
                </a>{" "}
                for assistance, sending them your case number and the following
                technical error:
              </p>
              {errorBox}
            </ServerSideWrapper>
          );
          break;
        default:
          errorMessage = (
            <ServerSideWrapper>
              {errorHeader}
              <h5>What should I do now?</h5>
              <p>
                If you believe that this error is not correct please contact the{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://flag.dol.gov/support/contact"
                >
                  Technical Help Desk
                </a>{" "}
                for assistance, sending them your application number and the
                following technical error:
              </p>
              {errorBox}
            </ServerSideWrapper>
          );
      }
    }
    // switch (formType) {
    //   case "790A":
    //     formName = "H-2A Agricultural Clearance Order";
    //     break;
    //   case "9142A":
    //     formName = "H-2A Temporary Emplymeny Certification";
    //     break;
    //   case "9035":
    //     formName = "Labor Condition Application for Nonimmigrant Workers";
    //     break;
    //   default:
    //     formName = "General Application Error";
    //     break;
    // }
    let message;
    if (this.props.formStatusType === "success") {
      message = successMessage;
    } else {
      message = errorMessage;
    }
    if (isQueueError) {
      message = successQueueErrorMessage;
    }

    return (
      <div>
        <Fragment>
          <div className="Form-submitted-status">
            {this.props.formStatusType === "loading" ? (
              <div className="submitting">
                <h2>
                  <i>Please do not refresh the page.</i> Submitting Form...
                </h2>
                <FaSpinner className="icon-spin submitting-spinner" />
              </div>
            ) : (
              <div className="form-submitted-modal-content text-left">
                <div
                  className="form-submitted-status-group"
                  style={{ marginTop: "50px" }}
                >
                  {this.props.formStatusType === "success" ? (
                    <div className="form-submitted-status-icon">
                      <FaRegCheckCircle
                        className={this.state.loaded ? "active" : ""}
                        strokeWidth={"20px"}
                        color={"#328443"}
                        size={"1.5em"}
                      />
                      <span className="form-submitted-status">
                        Your application has been received and submitted for
                        processing.
                      </span>
                    </div>
                  ) : (
                    <span
                      className="form-submitted-status"
                      style={{ color: "red" }}
                    >
                      Oops!
                    </span>
                  )}
                </div>
                <p className="form-submitted-status-message ">{message}</p>
                <button
                  type="button"
                  className="usa-button usa-button-primary"
                  onClick={this.onClickReturnToDashboard}
                >
                  Return to Dashboard
                </button>
              </div>
            )}
          </div>
        </Fragment>
      </div>
    );
  }
}

export default withRouter(FormSubmitted);
